import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { phoneNumValidate } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
let phoneNumber = class phoneNumber extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      title: "",
      required: "1",
      phoneNumber: ""
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        type: "string",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      phoneNumber: [{
        required: false,
        type: "string",
        validator: phoneNumValidate.phoneNumber,
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], phoneNumber.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], phoneNumber.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], phoneNumber.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], phoneNumber.prototype, "watchPostForm", null);
phoneNumber = __decorate([Component({
  name: "phoneNumber",
  components: {
    questionSettingTemplate
  }
})], phoneNumber);
export default phoneNumber;